export const chatChipNonVisblePages = [
  'experts-services',
  'experts-request',
  'reseller',
  'graphicDesign-Dashboard',
  'qr',
  'logomaker',
  '/acc/',
  '/xs/',
  '/env/',
  '/pdc/',
  '/apdc',
];

export const inlineButtonChatPages = [
  'ubikstudio',
  'studio', // design button,
  'design',
  'order-help-v2',
];
